$(document).ready(function(){
  $(document.body).on("click", "#addtocart", function (e) {
    var id = $(this).attr("data-id");
    e.preventDefault();
    datass = {
      id: id,
      quantity: 1,
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: datass,
      dataType: "json",
      success: function (cart) {
        window.location = "/cart";
      },
    });
  });
  $(document.body).on("click", "#remove-item", function () {
    var t = $(this);
    var id = t.data("id");
    $.ajax({
      type: "post",
      url: "/cart/change.js",
      data: "quantity=0&id=" + id,
      dataType: "json",
      success: function (cart) {
        location.reload();
      },
      error: function (xhr) {},
    });
  });
  $(window).scroll(function(){
     scroll = $(window).scrollTop();
     if (scroll >= 150) $('.site-header').addClass('fixed');
     else $('.site-header').removeClass('fixed');
  });
  $('.menupizhe h1').on('click', function(){
    $(this).toggleClass('active');
    $('#namepizamenu').slideToggle();
  });
  $('.faqs_list a.card-link').on('click', function(){
    $(this).parent().toggleClass('active');
    $(this).parent().siblings().removeClass('active');
  }); 
  $(document.body).on('click', '#namepizamenu a', function(e){
      var id = $(this).attr('href');
      $('html, body').animate({
            scrollTop: $(id).offset().top
        }, 700); 
    });
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
    $(document.body).on('click', '#namepizamenu a', function(e){
      // $('.menupizhe h1').toggleClass('active'); e.preventDefault();
      // $('#namepizamenu').slideToggle();
      
    });
  } 
});